import { render, staticRenderFns } from "./wowKitOrderSummary.vue?vue&type=template&id=588868f8"
import script from "./wowKitOrderSummary.vue?vue&type=script&lang=js"
export * from "./wowKitOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./wowKitOrderSummary.vue?vue&type=style&index=0&id=588868f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports